import { render, staticRenderFns } from "./TeacherCorrection.vue?vue&type=template&id=3f26f502&scoped=true&"
import script from "./TeacherCorrection.vue?vue&type=script&lang=js&"
export * from "./TeacherCorrection.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCorrection.vue?vue&type=style&index=0&id=3f26f502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f26f502",
  null
  
)

export default component.exports